import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import SideCard from './SideCard';
import ReminderCalendar from '../../../../components/ReminderCalender/ReminderCalender';
import Upcoming from './Upcoming';

interface HomeSideProps {
  isExpanded?: boolean;
  toggleFromParent?: () => void;
}

const HomeSide: React.FC<HomeSideProps> = ({
  isExpanded = true,
  toggleFromParent,
}) => {
  const [expanded, setExpanded] = useState<boolean>(isExpanded);

  useEffect(() => {
    setExpanded(isExpanded);
  }, [isExpanded]);

  const handleToggle = () => {
    setExpanded((prev) => !prev);
    if (toggleFromParent) toggleFromParent();
  };

  return (
    <Container expanded={expanded}>
      <ToggleButton onClick={handleToggle}>Toggle</ToggleButton>
      <SideCard />
      <ReminderCalendar />
      <Upcoming />
    </Container>
  );
};

export default HomeSide;

interface ContainerProps {
  expanded: boolean;
}

const Container = styled.div<ContainerProps>`
  width: ${({ expanded }) => (expanded ? '32%' : '0')};
  max-width: ${({ expanded }) => (expanded ? '' : '0')};
  overflow: hidden;
  transition: all 0.4s ease-in-out, max-width 0.4s ease-in-out;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  background-color: ${({ expanded, theme }) =>
    expanded ? 'white' : theme.palette.backgroundColor};

  @media (max-width: 1024px) {
    display: none;
  }
`;

const ToggleButton = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: none;
`;
